// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + ({"138":"profile","671":"subscriptions","883":"shop"}[chunkId] || chunkId) + "." + {"138":"44465b9d","542":"5d4ac284","655":"8996a35d","671":"6c2de2e7","883":"2700244f"}[chunkId] + ".css";
};